module.exports = __webpack_public_path__ + "img/building-inner.e98b082.png";